export const SERVICE_LANES = [
    { id: 'new', title: 'New', color: '#1976d2' },
    { id: 'in_shop', title: 'In the shop', color: '#E94F37' },
    { id: 'waiting_parts', title: 'Waiting on parts', color: '#f57c00' },
    { id: 'thermo_king', title: 'Thermo King', color: '#6a1b9a' },
    { id: 'ready', title: 'Ready', color: '#2e7d32' },
];

export const SERVICE_STATUSES = [
    ...SERVICE_LANES,
    { id: 'closed', title: 'Closed', color: '#616161' },
];

export const JOB_STATUSES = [
    { id: 'open', title: 'Not started' },
    { id: 'in_progress', title: 'In progress' },
    { id: 'waiting_parts', title: 'Waiting on parts' },
    { id: 'completed', title: 'Completed' },
    { id: 'rejected', title: 'Rejected' },
];

export function jobStatus(item) {
    if (JOB_STATUSES.some((status) => status.id === item?.status)) return item.status;
    return item?.done ? 'completed' : 'open';
}

export function jobStatusTitle(status) {
    return JOB_STATUSES.find((item) => item.id === status)?.title || 'Not started';
}

export function roleLabel(role) {
    if (role === 'service_admin') return 'Service Admin';
    if (role === 'service_viewer') return 'Service';
    if (role === 'company_admin') return 'Company Admin';
    if (role === 'admin') return 'Admin';
    return role || '';
}

export function whenLabel(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function isServiceRole(role) {
    return role === 'service_admin' || role === 'service_viewer';
}

export function canEditServiceTickets(role) {
    return role === 'admin' || role === 'service_admin';
}

export function laneTitle(status) {
    return SERVICE_STATUSES.find((lane) => lane.id === status)?.title || status || '';
}

export function truckOf(ticket) {
    const truck = ticket?.truck;
    if (!truck || typeof truck !== 'object') return {};
    return truck;
}

export function unitLabel(ticket) {
    return truckOf(ticket).unitNumber || 'Truck';
}

export function openJobs(ticket) {
    return (ticket?.items || []).filter((item) => {
        const status = jobStatus(item);
        return status !== 'completed' && status !== 'rejected' && String(item.text || '').trim();
    });
}

export function shortDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function ageLabel(ticket) {
    if (!ticket?.createdAt) return '';
    const start = new Date(ticket.createdAt);
    if (Number.isNaN(start.getTime())) return '';
    const days = Math.max(0, Math.floor((Date.now() - start.getTime()) / 86400000));
    if (days === 0) return 'Today';
    if (days === 1) return '1 day';
    return `${days} days`;
}
